const cinternoitems = {
/* ===== IMAGEN DE FONDO ===== */
  background:
    "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/MSCI_001.png",


    /* ===== ENCABEZADO CON ENLACES ===== */
  links: [
    { texto: "Inicio", url: "/Cinterno" },
    { texto: "Metodología", url: "/Cinterno/Metodologia" },
    { texto: "Componentes de Control", url: "/Cinterno/Control" },
    { texto: "Organigrama", url: "/Cinterno/Organigrama" },
    { texto: "Evidencias", url: "/Cinterno/Evidencias" }
  ],

  /* ===== CUADRO DE TEXTO ===== */
  cuadroTexto: {
    titulo: "¡Bienvenidos al Micrositio de Control Interno!",
    descripcion:
      "Nos complace darles la más cordial bienvenida a este espacio diseñado para fortalecer y promover una cultura de control interno dentro de nuestra Secretaría de Bienestar e Inclusión Social. El control interno es una parte fundamental de nuestras operaciones, ya que nos ayuda a salvaguardar, asegurar y cumplir con las regulaciones de acuerdo a las Disposiciones aplicables. <br /> <br /> En este micrositio, encontrarán una variedad de recursos, herramientas y capacitaciones que les permitirán entender mejor el concepto de control interno, así como su aplicación práctica en nuestro entorno laboral. Nuestro objetivo es empoderar a cada miembro de nuestro equipo para que comprenda su rol en el fortalecimiento de los controles internos y contribuya activamente a su implementación y mejora continua. <br /> <br /> ¡Esperamos que disfruten de su experiencia en nuestro Micrositio de Control Interno y que encuentren la información aquí proporcionada útil y valiosa para su desarrollo profesional! <br /><br /> ¡Bienvenidos nuevamente!"
  },

  /* ===== IMÁGENES ===== */
  imagenes: [
    {
      id: 1,
      src: ""
    },
    {
      id: 2,
      src: ""
    }
  ],

  /* ===== PDF VIEWER ===== */
  pdfViewer:
    "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/Disposiciones_Modelo_de_Control_Interno.pdf",
  tituloPdf: ""
};

export default cinternoitems;